export const PP_PREFIX = 'PARKPASS_';

// --- Facilities
export const FETCH_FACILITIES = `${PP_PREFIX}FETCH_FACILITIES`;
export const RESET_FACILITIES = `${PP_PREFIX}RESET_FACILITIES`;

// --- Pass Types
export const FETCH_PASS_TYPES = `${PP_PREFIX}FETCH_PASS_TYPES`;
export const RESET_PASS_TYPES = `${PP_PREFIX}RESET_PASS_TYPES`;

export const FETCH_PASS_TYPE = `${PP_PREFIX}FETCH_PASS_TYPE`;
export const RESET_PASS_TYPE = `${PP_PREFIX}RESET_PASS_TYPE`;

// --- Reservations
export const FETCH_RESERVATION = `${PP_PREFIX}FETCH_RESERVATION`;
export const CREATE_RESERVATION = `${PP_PREFIX}CREATE_RESERVATION`;
export const UPDATE_RESERVATION = `${PP_PREFIX}UPDATE_RESERVATION`;
export const DELETE_RESERVATION = `${PP_PREFIX}DELETE_RESERVATION`;
export const RESET_RESERVATION = `${PP_PREFIX}RESET_RESERVATION`;

// Cart/Account/Other
export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';
